<div class="grid total-vacations" (click)="openDetailTotalVacations(true, $event)">
  <div class="row d-flex d-align-center d-justify-between padding-bottom">
    <span class="total-vacations__title" *ngIf="totals && totals.length > 0">{{
      'MOT.VACATIONS.TOTAL_DAYS' | translate
    }}</span>
    <div
      class="total-vacations__more-info d-flex d-align-center"
      (click)="openDetailTotalVacations(false, $event)"
      *ngIf="!isMomoUser">
      <img class="total-vacations__icon-info" src="assets/imgs/notifications/info.svg" alt="info" />
      <span>{{ 'MOT.VACATIONS.MORE_INFO' | translate }}</span>
    </div>
  </div>
  <div class="row d-flex d-align-center">
    <app-total-vacations-element
      *ngFor="let item of totals; trackBy: trackByItems"
      class="d-flex d-align-center padding-bottom total-vacations__total-container"
      [totalElement]="item"></app-total-vacations-element>
  </div>
</div>
